export default __webpack_public_path__ + "static/5ee03b5089705e14a38b987aba99a03a.png";